export const AMEND_TYPES = {
  BOOKING: 'booking',
  OUTFIT: 'outfit',
  PARTY: 'party',
};

export default AMEND_TYPES;
